import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { DisplayObject } from "pixi.js";

export class TGRHiddenDisplayObjectControl<T extends DisplayObject> extends AbstractControl {

    constructor(protected element: T) {
        super();
        element.visible = false;
    }

    public setEnabled(enabled: boolean): void {
        this.enabled = false;
        this.element.visible = false;
    }
}
